import React, { Component } from 'react'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import { Link } from 'react-router-dom'
import AuthenticationService from '../general/AuthenticationService.js'

class DocumentoReporteComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: this.props.match.params.id,
            tipoDocumento: '',
            resumen: '',
            personasFisicas: [],
            sociedades: [],
            documentFileUrl: '',
            asuntos: '',
            entidadesRolesComentarios: [],
            entidades: [],
            fecha: '',
        }
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_DOCUMENTOS")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }
        if (Number(this.props.match.params.id) === -1) return

        ElementsDataService.retrieveElement("documentos", this.state.id).then(r => {
            const d = r.data
            this.setState({
                tipoDocumento: d.tipoDocumento || '',
                asuntos: d.asuntos || '',
                resumen: d.resumen || '',
                documentFileUrl: d.documentFileUrl || '',
                personasFisicas: d.personasFisicas || [],
                sociedades: d.sociedades || [],
                entidadesRolesComentarios: d.entidadesRolesComentarios || [],
                entidades: d.entidadesRolDocumento ? JSON.parse(d.entidadesRolDocumento).data : [],
                fecha: d.fecha || '',
            })
        })
    }

    render() {
        const { id, tipoDocumento, entidades, asuntos, resumen, documentFileUrl,
            sociedades, entidadesRolesComentarios, fecha } = this.state

        // Preparar string de sociedades para nombre de archivo
        const sociedadesStr = sociedades.map(s => s.razonSocial).join('_')

        const tipoBadgeColor = (tipo) => {
            if (!tipo) return { bg: '#f1f5f9', color: '#64748b', border: '#e2e8f0' }
            const t = tipo.toUpperCase()
            if (t.includes('ASAMBLEA')) return { bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe' }
            if (t.includes('MANDATO') || t.includes('PODER')) return { bg: '#fff7ed', color: '#c2410c', border: '#fed7aa' }
            if (t.includes('FISCAL') || t.includes('SAT') || t.includes('CIF') || t.includes('ACUSE')) return { bg: '#fefce8', color: '#ca8a04', border: '#fef08a' }
            return { bg: '#f5f3ff', color: '#7c3aed', border: '#ddd6fe' }
        }
        const tc = tipoBadgeColor(tipoDocumento)

        return (
            <div style={S.root}>
                <style>{css}</style>
                <div className="drep-root" style={S.inner}>

                    {/* Header */}
                    <div style={S.header}>
                        <div>
                            <p style={S.breadcrumb}>
                                <span style={{ color: '#3b82f6', cursor: 'pointer' }} onClick={() => this.props.history.push('/documentos')}>Documentos</span>
                                <span style={{ margin: '0 8px', color: '#cbd5e1' }}>›</span>
                                <span>{tipoDocumento || 'Reporte'}</span>
                            </p>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                                <h1 style={S.title}>{tipoDocumento || 'Documento'}</h1>
                                <span style={{ fontSize: '0.72rem', fontWeight: 700, padding: '4px 12px', borderRadius: 20, background: tc.bg, color: tc.color, border: `1px solid ${tc.border}`, whiteSpace: 'nowrap' }}>
                                    {tipoDocumento}
                                </span>
                            </div>
                            {fecha && <p style={{ margin: '4px 0 0', fontSize: '0.82rem', color: '#64748b' }}>📅 {fecha}</p>}
                        </div>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            {AuthenticationService.haveAuthorization("WRITE_DOCUMENTOS") && (
                                <button style={S.btnEdit} onClick={() => this.props.history.push(`/documentos/${id}`)}>
                                    ✏️ Editar
                                </button>
                            )}
                            {AuthenticationService.haveAuthorization("WRITE_DOCUMENTOS") && (
                                <button style={S.btnAdd} onClick={() => this.props.history.push('/documentos/-1')}>
                                    + Nuevo
                                </button>
                            )}
                        </div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>

                        {/* Datos principales */}
                        <Card icon="📄" title="Datos del Documento">
                            <InfoRow label="Tipo" value={tipoDocumento} />
                            <InfoRow label="Fecha" value={fecha} />
                            <InfoRow label="Asuntos" value={
                                asuntos ? (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                                        {asuntos.split(',').map((a, i) => (
                                            <span key={i} style={{ fontSize: '0.72rem', background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: 12, padding: '2px 8px' }}>
                                                {a.trim()}
                                            </span>
                                        ))}
                                    </div>
                                ) : '—'
                            } />
                            {resumen && (
                                <div style={{ marginTop: 14 }}>
                                    <p style={S.infoLabel}>Resumen</p>
                                    <p style={{ margin: 0, fontSize: '0.85rem', color: '#334155', lineHeight: 1.6, whiteSpace: 'pre-wrap', background: '#f8fafc', borderRadius: 10, padding: '12px 14px', border: '1px solid #f1f5f9' }}>
                                        {resumen}
                                    </p>
                                </div>
                            )}
                        </Card>

                        {/* Sociedades + Archivo */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                            <Card icon="🏢" title="Sociedades">
                                {sociedades.length === 0 ? (
                                    <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.82rem' }}>Sin sociedades asignadas</p>
                                ) : sociedades.map(s => (
                                    <Link key={s.id} to={`/sociedades/reportes/${s.id}`}
                                        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', borderBottom: '1px solid #f1f5f9', textDecoration: 'none', color: '#334155' }}>
                                        <span style={{ fontSize: '1rem' }}>🏢</span>
                                        <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#2563eb' }}>{s.razonSocial}</span>
                                    </Link>
                                ))}
                            </Card>

                            <Card icon="📎" title="Archivo">
                                {documentFileUrl ? (
                                    <button
                                        style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '12px 16px', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', border: 'none', borderRadius: 10, color: 'white', cursor: 'pointer', fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: '0.88rem' }}
                                        onClick={() => ElementsDataService.downloadS3File(
                                            `?fileName=${documentFileUrl}`,
                                            `${sociedadesStr}_${(asuntos || 'documento').replace(/,/g, '_')}.pdf`
                                        )}>
                                        <span style={{ fontSize: '1.1rem' }}>⬇</span> Descargar Documento
                                    </button>
                                ) : (
                                    <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.82rem', padding: '12px 0' }}>
                                        📭 No hay archivo cargado todavía
                                    </p>
                                )}
                            </Card>
                        </div>
                    </div>

                    {/* Tabla Entes y Roles */}
                    {entidades && entidades.length > 0 && (
                        <div style={{ ...cardStyle, marginTop: 14 }}>
                            <div style={cardHeaderStyle}>
                                <span>👥</span>
                                <h2 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#1e293b' }}>Entes y Roles</h2>
                            </div>
                            <div style={{ padding: '0', overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th className="drep-th">Ente</th>
                                            <th className="drep-th" style={{ width: 200 }}>Roles</th>
                                            <th className="drep-th">Comentarios</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {entidades.map(ente => (
                                            <tr key={ente.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                                <td style={{ padding: '12px 16px', verticalAlign: 'top' }}>
                                                    {ente.nombres?.map(item => (
                                                        <Link key={item.id}
                                                            to={`/${item.tipo === 'sociedad' ? 'sociedades' : 'personas-fisicas'}/reportes/${item.id}`}
                                                            style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4, textDecoration: 'none', color: '#2563eb', fontSize: '0.83rem', fontWeight: 600 }}>
                                                            <span>{item.tipo === 'sociedad' ? '🏢' : '👤'}</span>
                                                            {item.nombre}
                                                        </Link>
                                                    ))}
                                                </td>
                                                <td style={{ padding: '12px 16px', verticalAlign: 'top' }}>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                        {ente.roles?.map(r => (
                                                            <span key={r.id} style={{ fontSize: '0.72rem', fontWeight: 600, padding: '2px 8px', borderRadius: 12, background: '#f5f3ff', color: '#7c3aed', border: '1px solid #ddd6fe' }}>
                                                                {r.nombre}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </td>
                                                <td style={{ padding: '12px 16px', verticalAlign: 'top', fontSize: '0.83rem', color: '#475569', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
                                                    {ente.comentarios || <span style={{ color: '#cbd5e1' }}>—</span>}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

/* ── helpers ── */
const cardStyle = { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }
const cardHeaderStyle = { display: 'flex', alignItems: 'center', gap: 10, padding: '13px 22px', borderBottom: '1px solid #f1f5f9', background: '#fafcff' }

const Card = ({ icon, title, children }) => (
    <div style={cardStyle}>
        <div style={cardHeaderStyle}>
            <span>{icon}</span>
            <h2 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#1e293b' }}>{title}</h2>
        </div>
        <div style={{ padding: '16px 22px' }}>{children}</div>
    </div>
)

const InfoRow = ({ label, value }) => (
    <div style={{ display: 'flex', gap: 12, marginBottom: 10, alignItems: 'flex-start' }}>
        <span style={{ fontSize: '0.68rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.8px', textTransform: 'uppercase', minWidth: 80, paddingTop: 2 }}>{label}</span>
        <span style={{ fontSize: '0.85rem', color: '#334155', flex: 1 }}>{value || '—'}</span>
    </div>
)

const css = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
    .drep-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
    .drep-th { padding: 9px 16px; text-align: left; font-size: 0.68rem; font-weight: 700; color: #64748b; letter-spacing: 0.7px; text-transform: uppercase; border-bottom: 2px solid #e2e8f0; background: #f8fafc; }
`

const S = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 980, margin: '0 auto' },
    header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
    breadcrumb: { margin: '0 0 4px', fontSize: '0.78rem', color: '#94a3b8' },
    title: { margin: 0, fontSize: '1.45rem', fontWeight: 700, color: '#0f172a' },
    infoLabel: { margin: '0 0 6px', fontSize: '0.68rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.8px', textTransform: 'uppercase' },
    btnEdit: { padding: '9px 16px', background: 'white', border: '1px solid #e2e8f0', borderRadius: 10, color: '#475569', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', fontFamily: "'Inter', sans-serif" },
    btnAdd: { padding: '9px 16px', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.84rem', cursor: 'pointer', fontFamily: "'Inter', sans-serif", boxShadow: '0 4px 12px rgba(59,130,246,0.3)' },
}

export default DocumentoReporteComponent
